import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { getUserOrders, resetOrder } from '../actions/orderActions';
import DashboardOrderList from './DashboardOrderList';
import Spinner from './Spinner';

const Dashboard = (props: any) => {
  const { auth, orders, history } = props;

  useEffect(() => {
    props.getUserOrders(auth.user.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = () => {
    history.push('/dashboard/addresses');
  };

  const handleSignleOrder = (item) => {
    history.push(`/dashboard/order-details/${item._id}`);
  };

  return (
    <div className="dashboard-view">
      <div>
        <Helmet>
          <title>Account - Frozberries Victoria</title>
          <meta name="description" content="Account - Frozberries Victoria" />
        </Helmet>
      </div>
      <Row className="mx-5 my-3 border-bottom py-3">
        <Col>
          <h4 style={{ fontWeight: 'bolder' }}>My Account</h4>
        </Col>
      </Row>
      <Row className="mx-5 my-3 border-bottom  py-3">
        <Col>
          <h5 style={{ fontWeight: 'bold' }}>Order History</h5>
          {orders.fetching ? (
            <div>
              <Spinner />
            </div>
          ) : orders.userOrders.length === 0 ? (
            <p>You haven't placed any orders yet.</p>
          ) : (
            <DashboardOrderList />
          )}
        </Col>
      </Row>
      <Row className="mx-5 my-3  py-3">
        <Col>
          <h5 style={{ fontWeight: 'bold' }}>Account Details</h5>
          <p>
            {auth.user.firstName} {auth.user.lastName}
          </p>
          <p>Phone Number: {auth.user.phoneNumber}</p>

          {auth.user.adress.length !== 0 &&
            auth.user.adress.map(
              (eachAdress, index) =>
                eachAdress.addressType === 'default' && (
                  <p key={index}>
                    Address:
                    <span> {eachAdress.streetAdress} </span>
                    <span>
                      {eachAdress.suburb.toUpperCase()} VICTORIA {eachAdress.zipCode}
                    </span>
                  </p>
                )
            )}
          <Button
            onClick={handleClick}
            color="dark"
            outline
            className="btn btn-sm font-weight-bold my-3"
          >
            View Addresses ({auth.user.adress.length})
          </Button>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  errors: state.errors,
  auth: state.form,
  cart: state.cart,
  fullPageLoading: state.fullPageLoading,
  orders: state.orders,
});

export default connect(mapStateToProps, { getUserOrders, resetOrder })(Dashboard);
